import { FC } from 'react'

import { useEmbedBridge } from '@app/hooks/useEmbedBridge'

const EmbedBridge: FC = () => {
  useEmbedBridge()
  return null
}

export default EmbedBridge
